var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72473 12.9966C3.72473 7.33973 3.72473 4.51131 5.48209 2.75394C7.23946 0.996582 10.0679 0.996582 15.7247 0.996582C21.3815 0.996582 24.21 0.996582 25.9674 2.75394C27.7247 4.51131 27.7247 7.33973 27.7247 12.9966C27.7247 18.6534 27.7247 21.4818 25.9674 23.2393C24.21 24.9966 21.3815 24.9966 15.7247 24.9966C10.0679 24.9966 7.23946 24.9966 5.48209 23.2393C3.72473 21.4818 3.72473 18.6534 3.72473 12.9966Z",
    stroke: "#D3A621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72473 9.20752H27.7247",
    stroke: "#D3A621",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40857 5.41846H9.42155",
    stroke: "#D3A621",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4612 5.41846H14.4742",
    stroke: "#D3A621",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0577393 0.197754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.a2d063ec38a00454492496bdce55058c.svg";
export { ForwardRef as ReactComponent };